export default __webpack_public_path__ + "1b6340b1b33edb5edf01cdbfbc5897db.svg";